module.exports = __webpack_public_path__ + "img/refferal.ef199d9.svg";